/**
 * FAQ data dipakai di halaman User (beranda) dan Admin (referensi + salin jawaban).
 */
export const faqList = [
  {
    id: 1,
    question: 'Bagaimana cara memulai chat?',
    answer:
      'Pilih kategori pertanyaan di atas yang sesuai dengan kebutuhan Anda, lalu mulailah mengirim pesan. Tim kami akan merespons secepat mungkin.'
  },
  {
    id: 2,
    question: 'Apakah saya harus login untuk chat?',
    answer:
      'Tidak wajib. Anda bisa chat sebagai tamu (guest). Namun jika Anda mendaftar atau login, riwayat percakapan akan tersimpan dan bisa Anda buka kembali kapan saja.'
  },
  {
    id: 3,
    question: 'Saya sudah lari, tapi belum tercatat di dashboard profile saya, kenapa ya?',
    answer:
      'Sinkronisasi dari Strava ke sistem <strong>RUNTERA</strong> dilakukan secara periodik, yaitu:<br><br>' +
      '• <strong>Siang</strong>: 11.00 – 13.00 WIB<br>' +
      '• <strong>Malam</strong>: 19.00 – 21.00 WIB<br><br>' +
      'Jika setelah periode tersebut aktivitas lari kamu masih belum tercatat, silakan periksa ketentuan berikut:<br><br>' +
      '1. Type olahraga harus <strong>Run</strong>, bukan Walk atau olahraga lainnya.<br>' +
      '2. Pace lari berada di rentang <strong>4 – 11 menit/km</strong>.<br>' +
      '3. Selisih <strong>moving time</strong> dan <strong>elapsed time</strong> maksimal <strong>2 menit</strong>.<br>' +
      '4. Penamaan activity harus sesuai format <strong>RVR-idparticipant</strong>.<br>' +
      '5. Status activity harus <strong>Public</strong>, bukan Private.<br><br>' +
      'Jika semua kriteria di atas sudah sesuai namun data masih belum masuk, silakan <strong>login terlebih dahulu</strong>, pilih kategori <strong>Pencatatan Lari</strong>, lalu sampaikan activity yang bermasalah.'
  },
  {
    id: 4,
    question: 'Di mana saya bisa mendapatkan ID participant?',
    answer:
      'Silakan login ke <a href="https://runtera.id/auth/signin" target="_blank" rel="noopener noreferrer">https://runtera.id/auth/signin</a> untuk melihat ID participant Anda.'
  },
  {
    id: 5,
    question: 'Jika lupa email atau password untuk login di akun RUNTERA bagaimana?',
    answer:
      'Silakan konsultasi melalui Customer Service dengan <strong>login terlebih dahulu</strong>, lalu pilih kategori <strong>Akun</strong> dan sampaikan kendala yang Anda alami.'
  },
  {
    id: 6,
    question: 'Berapa lama waktu respons?',
    answer:
      'Tim customer service <strong>RUNTERA</strong> berusaha merespons secepat mungkin. Jam operasional mengikuti jam kerja standar. Terima kasih atas kesabaran Anda.'
  },
  {
    id: 7,
    question: 'Racepack saya kapan dikirim ya?',
    answer:
      'Pengiriman racepack diperkirakan akan dilakukan pada <strong>awal Maret 2026</strong>.'
  },
  {
    id: 8,
    question: 'Apa itu moving time dan elapsed time?',
    answer:
      '<strong>Moving time</strong> adalah waktu saat kamu benar-benar bergerak berlari.<br>' +
      '<strong>Elapsed time</strong> adalah waktu sejak menekan tombol mulai hingga tombol selesai di Strava.<br><br>' +
      'Agar aktivitas tercatat dengan baik, setelah memulai rekaman di Strava sebaiknya tetap bergerak berlari dan tidak berhenti lama hingga activity selesai.'
  }
];

/**
 * Mengubah string HTML jadi teks biasa (untuk copy-paste admin).
 * Tag <br> dijadikan newline agar struktur/enter tetap saat dipaste di chat.
 */
export function faqAnswerToPlainText(html) {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;

  function collectText(node) {
    if (!node) return '';
    if (node.nodeType === Node.TEXT_NODE) return node.textContent || '';
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = node.tagName && node.tagName.toLowerCase();
      if (tag === 'br') return '\n';
      let out = '';
      for (let i = 0; i < node.childNodes.length; i++) {
        out += collectText(node.childNodes[i]);
      }
      return out;
    }
    return '';
  }

  return collectText(div).trim().replace(/\n{3,}/g, '\n\n');
}
